import axios from 'axios';
import { getFaviconFile, getLogoFile, getPath } from '../lib/white-cache';
import { ShopSignInterface } from '../../../interfaces/shop-sign';
import { Theme } from '../utils/default-theme';
import { defaultCustomTheme } from '../utils/default-custom-theme';
import { privacyPolicyModeToNumber } from '../utils/default-privacy-policy';

export const manageShopSign = async (
  data: ShopSignInterface,
  palette: any,
  typography: any,
  components: any,
  customTheme: any,
  software: string,
  isConsole: boolean,
  shopSignId?: string
): Promise<string> => {
  // La form usa il mode come stringa ('link'|'paste'|'template'); il backend
  // vuole l'enum numerico (Paste=0, Template=1, Link=2). L'URL va valorizzato
  // solo in modalità Link.
  const privacyMode = data.privacyPolicyMode as unknown as
    | 'link'
    | 'paste'
    | 'template'
    | undefined;

  let shopSign: any = {
    ...data,
    imoPriority: isConsole && software === 'bb' ? 0 : data.imoPriority,
    emailPriority: isConsole && software === 'bb' ? 1 : data.emailPriority,
    smsPriority: isConsole && software === 'bb' ? 0 : data.smsPriority,
    privacyPolicyMode: privacyPolicyModeToNumber(privacyMode),
    privacyPolicyUrl: privacyMode === 'link' ? data.privacyPolicyUrl || null : null,
  };

  const logo = getLogoFile();
  const favicon = getFaviconFile();

  if (shopSignId === undefined || shopSignId === '') {
    const theme = JSON.stringify(Theme);
    const customConfigurationJson = JSON.stringify(defaultCustomTheme);
    //? create
    shopSign = {
      ShopSign: {
        ...shopSign,
        configurationJson: theme,
        customConfigurationJson: customConfigurationJson,
        PreviewConfigurationJson: theme,
        PreviewCustomConfigurationJson: customConfigurationJson,
        logo: logo === undefined ? shopSign.logo : logo,
        favicon: favicon === undefined ? shopSign.favicon : favicon,
      },
    };
  } else {
    //? modify
    shopSign = {
      ShopSign: {
        ...shopSign,
        logo: logo,
        favicon: favicon,
        ShopSignId: shopSignId,
      },
    };
  }
  if (
    shopSign.ShopSign.whatsappNumber === null ||
    shopSign.ShopSign.whatsappNumber === ''
  )
    delete shopSign.ShopSign.whatsappNumber;
  const body = new FormData();
  for (const key in shopSign.ShopSign) {
    if (Object.prototype.hasOwnProperty.call(shopSign.ShopSign, key)) {
      const element = shopSign.ShopSign[key];
      shopSign['ShopSign.' + key] = element;
      body.append(`ShopSign.${key}`, element);
    }
  }

  delete shopSign.ShopSign;

  let result;

  try {
    const {
      data: { data: resultCall },
    } = await axios.post(`${getPath()}/ShopSign/Management`, body, {
      headers: {
        // 'application/json' is the modern content-type for JSON, but some
        // older servers may use 'text/json'.
        // See: http://bit.ly/text-json
        'Content-Type': 'multipart/form-data',
      },
    });
    result = shopSignId && shopSignId !== '' ? shopSignId : resultCall;
  } catch (err) {
    console.error(err);
    return '';
  }

  try {
    await axios.put(`${getPath()}/ShopSign/Theme`, {
      id: result,
      PreviewConfigurationJsonDynamic: { palette, typography, components },
      PreviewCustomConfigurationJsonDynamic: customTheme,
      configurationJsonDynamic: { palette, typography, components },
      customConfigurationJsonDynamic: customTheme,
    });
  } catch (err) {
    console.error(err);
    return '';
  }
  return result;
};